import React from 'react';
import WaitCube from '../../../WaitCube.js'
import {_GPY,__GPYPost , __GPYGet,__GPYPostDownload} from '../../../env.js'
import moment from 'moment';
import 'moment/locale/de';

class Tournament extends React.Component {

	constructor(props) {
			super(props);
			this.state = {
				tournamentsIsLoaded:false,
				tournaments:undefined,
				gamesIsLoaded:false,

				currentTournament : {id:-1,name:"",data:"{}",_data:{}},
			};
	}

  storeTournament(){
		this.state.currentTournament.data = JSON.stringify(this.state.currentTournament._data);
		__GPYPost('storeTournament',this.state.currentTournament,(res) => {
	  },(err)=>{
	  });
	}

  componentDidMount(){
		this.getTournaments();
		this.getGames();
	}

	genLayouterArray(i){
			var rows = 0;
			var teams = i;
			var res = [];
			while( (teams/2) >= 1 ) {
				console.log(teams);
				teams = teams/2;
				var games = new Array(teams);
				for (var i = 0; i < games.length; i++) {
					games[i] = -1;
				}
				res.push( games );
			}

			return res;
	}

  setTeamCount(e) {
		var t = this.state.currentTournament
		t._data.teamCount = parseInt(e.target.value);
		t._data.games = this.genLayouterArray(t._data.teamCount);
		this.setState({currentTournament:t});
	}

	onChangeName(e) {
			var t = this.state.currentTournament;
			t.name = e.target.value;
			this.setState({currentTournament:t});
	}

	setGameinTournament(row,col,e){
		var t = this.state.currentTournament;
		t._data.games[row][col] = parseInt(e.target.value);
		this.setState({currentTournament:t});
	}
	getGames(obj) {
	       if(obj === undefined) {
	         obj = {};
	       }
	       __GPYPost('getGames',obj,(res) => {
	          this.setState({
	           gamesIsLoaded: true,
	           games: res,
	          });
	       },(err)=>{
	       });
	   }

		 getTournaments(obj) {
	 	       if(obj === undefined) {
	 	         obj = {};
	 	       }
	 	       __GPYPost('getTournaments',obj,(res) => {
						  res.Tournaments.Tournament.map((t) => {
									t._data = JSON.parse(t.data);
							});
	 	          this.setState({
	 	           tournamentsIsLoaded: true,
	 	           tournaments: res,
	 	          });
	 	       },(err)=>{
	 	       });
	 	   }


	render(){



			return (
				<div>
						<div className="row">
							 <div className="col-12 col-lg-3 col-xl-3">

										<div className="row pt-2">
												<div className="col-8"><h3>{_GPY.i18n.get('gametype_SoccerFootball_games_gamelist_headline')}</h3></div>
												<div className="col-4 text-right align-bottom"><button type="button" onClick={() => this.setState({currentTournament : {id:-1,name:"",data:"{}",_data:{}}})} className="btn btn-light btn-sm"><span className="glyphicon glyphicon-plus"/></button></div>
										 </div>

										 <div className="row">
												<div className="col">
													 <div className="list-group">
															{this.state.tournamentsIsLoaded ? this.state.tournaments.Tournaments.Tournament.map((t) => {
																	return (<button key={t.id} onClick={() => this.setState({currentTournament : t})} className={t.id === this.state.currentTournament.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
																						<div className="d-flex w-100 justify-content-start"><strong>{t.name}</strong></div>
																					</button>);
															}) :  <WaitCube/>  }

													 </div>
												 </div>
										 </div>
 							 </div>

							 <div className="col-12 col-lg-9 col-xl-9 pt-1">



								<h3>{_GPY.i18n.get('gametype_SoccerFootball_referee_headline')}</h3>
								<div className="card bg-light border-success ">
										<div className="card-header">{_GPY.i18n.get('gametype_SoccerFootball_referee_box_headline')}</div>

										<div className="row p-3">
												<div className="col-6">
														<div className="form-group">
																<label htmlFor="inputTeamName">{_GPY.i18n.get('gametype_SoccerFootball_referee_box_form_input_firstname_title')}</label>
																<input name="teamName" onChange={(e) => this.onChangeName(e)} value={this.state.currentTournament.name} type="text" id="inputTeamName" className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_referee_box_form_input_firstname_placeholder')}/>
														</div>
												</div>
										</div>
									</div>
								</div>

					</div>

					{this.state.currentTournament.id>0?
						<div className="row">
						<div className="col-12">
						<h3>{_GPY.i18n.get('gametype_SoccerFootball_referee_headline')}</h3>
						<div className="card bg-light border-success ">
							<div className="card-header">{_GPY.i18n.get('gametype_SoccerFootball_referee_box_headline')}</div>
							<div className="card-body">


							<form>

							  <div className="form-group">
							    <label  htmlFor="exampleFormControlSelect1">Select Teams</label>
							    <select className="form-control" id="exampleFormControlSelect1" value = {this.state.currentTournament._data.teamCount} onChange={(e)=>this.setTeamCount(e)}>
							      <option value="4">4</option>
							      <option value="8">8</option>
							      <option value="16">16</option>
							      <option value="32">32</option>
										<option value="64">64</option>
							    </select>
							  </div>
							</form>

							teamCount: {this.state.currentTournament._data.teamCount} <code>{ JSON.stringify(this.state.currentTournament._data.games) }</code>


<div className="row p-3">
								{this.state.currentTournament._data.games!==undefined ? this.state.currentTournament._data.games.map((row,idx) =>
									<div className="col-2 col align-self-center">
											{row.map((col,c) =>
													<div className="row p-2">
													<select className="form-control" id="exampleFormControlSelect1" value={col} onChange={(e)=>{this.setGameinTournament(idx,c,e)}}>
													<option value="-1">Select Game</option>
													{this.state.gamesIsLoaded ? this.state.games.Games.Game.map((g) =>
														<>
														<option value={g.id}>{g.gameName}</option>
														</>
													):""}
													</select>
													</div>
											)}
									</div>
								):""}
</div>

							</div>
							</div>
					  </div>
						</div>
					: ""}
					<div className="row pt-2 justify-content-end">
						<div className="col-6 text-right">
							<button type="button" className="btn btn-success" onClick={()=>{this.storeTournament()}}><span className={this.state.currentTournament.id>0?"glyphicon glyphicon-ok":"glyphicon glyphicon-plus"}/></button>
						</div>
					</div>
			</div>

			);
	}

}
export default Tournament;
